import { api } from './api';

/** Photo upload: downscale in the browser first so phone photos upload fast on 4G. */
export async function uploadPhoto(path: string, file: File, opts: { max?: number; caption?: string } = {}) {
  const blob = await downscale(file, opts.max ?? 640);
  const fd = new FormData();
  if (opts.caption) fd.append('caption', opts.caption);
  fd.append('file', blob, 'photo.jpg');
  return api(path, { form: fd, method: 'POST' });
}

async function downscale(file: File, max: number): Promise<Blob> {
  try {
    const bmp = await createImageBitmap(file);
    const scale = Math.min(1, max / Math.max(bmp.width, bmp.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(bmp.width * scale);
    canvas.height = Math.round(bmp.height * scale);
    canvas.getContext('2d')!.drawImage(bmp, 0, 0, canvas.width, canvas.height);
    return await new Promise<Blob>((res) => canvas.toBlob((b) => res(b ?? file), 'image/jpeg', 0.85));
  } catch {
    return file;
  }
}
